/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { createSelector } from 'reselect';
import {
  currentUserIdSelector,
  currentCohortPathSelector,
} from '../Auth/selectors';

const groupsSelector = (state) => state.Groups;

export const groupsByPathSelector = createSelector(groupsSelector, (groups) => {
  return groups.get('byPath', Immutable.Map());
});

export const groupsByUserByCohortByCategory = createSelector(
  groupsByPathSelector,
  (groups) => {
    let byUserByCohortByCategory = Immutable.Map();

    for (const group of groups.values()) {
      for (const user of group.get('members').values()) {
        byUserByCohortByCategory = byUserByCohortByCategory.updateIn(
          [user.get('user'), group.get('cohort'), group.get('category')],
          Immutable.OrderedMap(),
          (groupsById) => {
            return groupsById
              .set(group.get('id'), group)
              .sortBy((g) => g.get('title'));
          }
        );
      }
    }

    return byUserByCohortByCategory;
  }
);

export const currentUserGroupsByCategory = createSelector(
  currentUserIdSelector,
  currentCohortPathSelector,
  groupsByUserByCohortByCategory,
  (userId, cohortPath, groups) => {
    return groups.getIn([userId, cohortPath], Immutable.Map());
  }
);

export const groupsById = createSelector(groupsByPathSelector, (groups) => {
  let byId = Immutable.Map();
  for (const group of groups.values()) {
    byId = byId.set(group.get('id'), group);
  }

  return byId;
});

export const groupsByGroupPagesPath = createSelector(
  groupsByPathSelector,
  (groups) =>
    groups.reduce(
      (current, group) => current.set(group.get('groupPagesPath'), group),
      Immutable.Map()
    )
);

export const groupsForCurrentCohortSelector = createSelector(
  currentCohortPathSelector,
  groupsByPathSelector,
  currentUserIdSelector,
  (cohortPath, groups, userId) => {
    let allgroups = Immutable.Map();
    let selectedMyGroups = Immutable.Map({
      admin: Immutable.List(),
      member: Immutable.List(),
    });
    let selectedOtherGroups = Immutable.Map({
      open: Immutable.List(),
      close: Immutable.List(),
    });

    for (const group of groups.values()) {
      if (group.get('cohort') === cohortPath) {
        allgroups = allgroups.set(group.get('id'), group);
      }
    }

    allgroups.forEach((g) => {
      if (
        g.get('members').find((m) => {
          return m.get('user') === userId;
        })
      ) {
        if (
          g.get('members').find((m) => {
            return m.get('user') === userId && m.get('admin');
          })
        ) {
          selectedMyGroups = selectedMyGroups.update('admin', (list) =>
            list.push(g)
          );
        } else {
          selectedMyGroups = selectedMyGroups.update('member', (list) =>
            list.push(g)
          );
        }
      } else if (g.get('isInviteOnly')) {
        selectedOtherGroups = selectedOtherGroups.update('close', (list) =>
          list.push(g)
        );
      } else {
        selectedOtherGroups = selectedOtherGroups.update('open', (list) =>
          list.push(g)
        );
      }
    });

    return Immutable.Map({
      selectedMyGroups,
      selectedOtherGroups,
    });
  }
);

export const makeSelectCohortGroupsHasLoaded = (cohortPath) =>
  createSelector(groupsSelector, (state) =>
    state.getIn(['byCohortPath', cohortPath, 'hasLoaded'], false)
  );

export const makeSelectCohortGroupsIsLoading = (cohortPath) =>
  createSelector(groupsSelector, (state) =>
    state.getIn(['byCohortPath', cohortPath, 'isLoading'], false)
  );
